export default function getScalingParameters(metaData, imageId) {
    const modalityLutModule = metaData.get('modalityLutModule', imageId) || {};
    const generalSeriesModule = (metaData.get('generalSeriesModule', imageId) ||
        {});
    const { modality } = generalSeriesModule;
    const rescaleSlope = modalityLutModule.rescaleSlope;
    const rescaleIntercept = modalityLutModule.rescaleIntercept;
    if (rescaleSlope === 1 &&
        (rescaleIntercept === 0 || rescaleIntercept == null)) {
        return undefined;
    }
    const scalingParameters = {
        rescaleSlope,
        rescaleIntercept,
        modality,
    };
    const scalingModules = metaData.get('scalingModule', imageId) || {};
    return {
        ...scalingParameters,
        ...(modality === 'PT' && { suvbw: scalingModules.suvbw }),
        ...(modality === 'RTDOSE' && {
            doseGridScaling: scalingModules.DoseGridScaling,
            doseSummation: scalingModules.DoseSummation,
            doseType: scalingModules.DoseType,
            doseUnit: scalingModules.DoseUnit,
        }),
    };
}
